class SearchFilters {
  constructor(element) {
    this.input = element.querySelector('.f-filters__searchInput');
    this.items = element.querySelectorAll('.f-filters__facetName');
    this.remove = element.querySelector('.f-filters__searchDelete');

    if (!this.input) {
      return;
    }

    this.input.addEventListener('input', this.filters.bind(this));
    this.input.addEventListener('keydown', (e) => {
      if (e.keyCode == 13) {
        e.preventDefault();
      }
    });

    if (!this.remove) {
      return;
    }

    this.remove.addEventListener('click', () => {
      this.input.value = '';
      this.filters();
    });
  }

  filters() {
    const query = this.input.value.trim().toLowerCase();

    for (const item of this.items) {
      if (query === '') {
        item.parentNode.style.display = '';
        item.parentNode.querySelector('input').removeAttribute('tabindex');
        item.innerHTML = item.innerText;
      } else if (item.innerText.toLowerCase().includes(query)) {
        item.parentNode.style.display = 'block';
        item.parentNode.querySelector('input').removeAttribute('tabindex');
        item.innerHTML = item.innerText.replaceAll(new RegExp(query, 'gi'), '<mark>$&</mark>');
      } else {
        item.parentNode.style.display = 'none';
        item.parentNode.querySelector('input').setAttribute('tabindex', '-1');
      }
    }
  }
}

for (const element of document.querySelectorAll('.js-filters-facets')) {
  element.searchFiltersInstance = new SearchFilters(element);
}
